export default "/img/LV.1f84e457b3583cd80d8b13f6f5e10677.png";